// JobClose AI · Pass 4C · No Access landing
//
// Shown when a contractor's next authenticated request is rejected
// with 403 `membership_inactive` (they were removed from a company
// after their token was issued). Local session already cleared by
// the axios interceptor in lib/api.js. This page must NEVER expose
// prior-company data.
import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";

const NoAccess = () => (
  <div
    className="min-h-screen flex items-center justify-center bg-[var(--jc-bg,#f6f7fb)] px-6"
    data-testid="no-access-page"
  >
    <div className="max-w-md w-full text-center">
      <div className="mx-auto w-12 h-12 rounded-full bg-[var(--jc-border)] flex items-center justify-center mb-4">
        <ShieldOff size={22} className="text-[var(--jc-text-soft)]" />
      </div>
      <h1 className="font-display text-2xl">You no longer have access to this company workspace.</h1>
      <p className="mt-3 text-sm text-[var(--jc-text-soft)]">
        Your JobClose identity is still yours — a new company can invite
        this email to join them anytime.
      </p>
      <div className="mt-6 flex justify-center gap-3">
        <Link
          to="/login"
          data-testid="no-access-login-link"
          className="px-4 py-2 rounded-md text-xs font-semibold jc-btn-primary"
        >
          Sign in
        </Link>
        <Link
          to="/"
          data-testid="no-access-home-link"
          className="px-4 py-2 rounded-md text-xs font-semibold border border-[var(--jc-border)] text-[var(--jc-text)] hover:bg-[var(--jc-bg)]"
        >
          Back to JobClose
        </Link>
      </div>
    </div>
  </div>
);

export default NoAccess;
